import { createRouter, createWebHistory } from "@ionic/vue-router";
// import * as views from "@/views/views";
import * as views from "@/views/au-views";
import store from "@/store/store";
import moment from "moment";
import { instance as axios } from "@/hooks/axios/axios";
import pureAxios from "axios";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { stampHideRecommendedRateForLocum } from '@/helpers/utility/locumShiftRates.js';
import employerType from '@/helpers/employer-type/employerType';
import { ElMessage } from "@/components/Vendor/Element";


const checkOneSignalSubscription = function (store) {
    const user = store.getters.GET_USER_DATA;

    if (user && user.id) {
        const oneSignalUserId = window.localStorage.getItem("one-signal-user-id");
        const oneSignalSubscriptionExists = window.localStorage.getItem(
            "one-signal-subscribed"
        );

        if (oneSignalUserId && !oneSignalSubscriptionExists) {
            const options = {
                method: "POST",
                url: "/one-signal/subscribe",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                data: {
                    one_signal_player_id: oneSignalUserId,
                },
            };

            axios
                .request(options)
                .then(function () {
                    window.localStorage.setItem("one-signal-subscribed", "1");
                    //alert('Subscribed successfully');
                })
                .catch(function (error) {
                    console.error(error);

                    if (error.response) {
                        // Request made and server responded
                        //alert(JSON.stringify(error.response));
                        //alert(error.response.status);
                        //alert('Failed to subscribe to push notifications');
                    } else if (error.request) {
                        // The request was made but no response was received
                        //alert(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        //alert(error.message);
                    }
                });
        }
    }
};

const withPrefix = (prefix, routes) =>
    routes.map((route) => {
        route.path = prefix + route.path;
        return route;
    });

const routes = [
    {
        path: '/shift/applicants/:shiftId',
        name: 'shift_applicants',
        component: () => import("@/views/Job/JobApplicants.vue"),
        beforeEnter(to, from, next) {
            if (to.params) {
                if (from.name == "search") {
                    store.dispatch("clearJobShiftsBookPageData");
                }
                (async () => {
                    try {
                        let resp = await store.dispatch("GET_SHIFT_INFO", {
                            shiftId: to.params.shiftId,
                            params: {
                                with:
                                    "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,abilities,locum.billingInfo,shiftApplications",
                            },
                        });
                        to.params.shift = resp.data;
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next({
                    name: "home",
                });
            }
        },

    },
    {
        path: "/maintenance",
        name: "maintenance_mode",
        component: views.MaintenanceMode,
        props: true,
    },
    {

        path: "/billing/session/:hash",
        name: "billing_session",
        component: views.BillingSession,
        meta: {
            requiresAuth: false,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    await store.dispatch("GET_BILLING_SESSION", to.params.hash);
                    next();
                } catch (error) {
                    console.log(error);
                    next({ name: "profile_stripe_payment" })
                }
            })();
        },
    },
    {

        path: "/billing/session-success",
        name: "billing_session_success",
        component: views.BillingSessionSuccess,
        meta: {
            requiresAuth: false,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {

                    next();
                } catch (error) {
                    console.log(error);
                }
            })();
        },
    },
    {

        path: "/billing/session-failed",
        name: "billing_session_failed",
        component: views.BillingSessionFailed,
        meta: {
            requiresAuth: false,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {

                    next();
                } catch (error) {
                    console.log(error);
                }
            })();
        },
    },
    {
        name: "home",
        beforeEnter(to, from, next) {
            next({
                name: "search",
            });
        },
    },
    {
        path: "/coming-soon",
        name: "coming_soon",
        component: () => import("@/views/LockScreen/ComingSoon.vue"),
        meta: {
            requiresAuth: true,
        },
    },


    {
        path: "/",
        name: "search",
        component: () => {
            const userData = store.getters.GET_USER_DATA;
            const isPharmacyWithParentId1 = employerType(userData).isCommunityPharmacy;
            switch (store.getters.getAccountType) {
                case "agency":
                    return import("@/views/Search/Agency/SearchAgency.vue");
                case "locum":
                    return import("@/views/Search/Locum/SearchLocum.vue");
                case "pharmacy":
                    if (isPharmacyWithParentId1) {
                        if (userData?.site['isRecordShiftsEnabled'] || userData?.site['is_record_shifts_enabled']) {
                            return import("@/views/Search/Pharmacy/SearchPharmacy.vue");
                        } else {
                            return import("@/views/JobListing/JobPoster/JobPosterIndex.vue");
                        }
                    } else {
                        return import("@/views/JobListing/JobPoster/JobPosterIndex.vue");
                    }
            }
        },
        meta: {
            requiresAuth: true,
        },
        beforeEnter: async (to, from, next) => {
            try {
                checkOneSignalSubscription(store);
        
                // Run API calls (parallel for speed)
                await Promise.all([
                    store.dispatch("GET_NOTIFICATIONS_MESSAGES", {
                        params: { hideLoading: true },
                    }),
                    store.dispatch("SET_CURRENT_USER_DATA", {
                        with:
                            "settings,billingInfo,schedule,bankVerification,airwallexInfo,address,push_notifications,config.hours_before_shift_lock",
                    }),
                ]);
        
                const userData = store.getters.GET_USER_DATA;
        
                // Contractor onboarding check
                if (userData.role === "locum" && userData?.contractorOnboarding) {
                    return next({ name: "welcome_contractor" });
                }
        
                next();
            } catch (error) {
                console.error(error);
                next(); // or redirect to error page if needed
            }
        },
    },

    {
        path: "/intro",
        name: "intro",
        component: views.Intro,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            const userData = store.getters.GET_USER_DATA;

            if (userData.role === 'job-seeker') {
                next({ name: 'job_seeker_index' });
            } else if (userData.intro) {
                next({ name: 'home' });
            } else {
                next();
            }
        },
    },
    {
        path: "/onboard/intro",
        name: "onboard_intro",
        component: views.InternalPoolIntro,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (store.getters.GET_USER_DATA.intro) {
                next({
                    name: "home",
                });
            } else {
                next();
            }
        },
    },
    {
        path: "/emulate/:token",
        name: "emulate",
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    await store.dispatch("CLEAR_USER_DATA");
                    await pureAxios
                        .get(process.env.VUE_APP_BASEURL + "/me", {
                            headers: {
                                Authorization: "Bearer " + to.params.token,
                            },
                        })
                        .then(async function (response) {
                            await store.commit("SET_USER_DATA", response.data.user);
                            await store.dispatch("AUTH_SUCCESS", to.params.token);
                            await window.localStorage.setItem("emulate", "1");

                            next({
                                name: "intro",
                            });
                        });
                } catch (error) {
                    console.log(error);
                    next({
                        name: "auth",
                    });
                }
            })();
        },
    },
    {
        path: "/welcome",
        name: "welcome",
        component: views.Welcome,
        meta: {
            requiresNotAuth: true,
        },
        beforeEnter(to, from, next) {
            if (!store.getters.GET_USER_DATA.email) {
                next({
                    name: "auth",
                });
            }
            if (from.name == "auth") {

                (async () => {
                    try {
                        const authType = await store.dispatch("CHECK_USER_EXIST", {
                            login:
                                store.getters.GET_USER_EMAIL || store.getters.GET_USER_PHONE,
                        });
                        if (authType) {
                            next({
                                name: "auth_password",
                            });
                        } else {
                            next();
                        }
                    } catch (error) {
                        throw error.response.data;
                    }
                })();
            } else {
                next();
            }
        },
    },
    {
        path: "/login",
        name: "login_re_direct",
        component: views.LoginRedirect,
        meta: {
            requiresNotAuth: true,
        },
    
    },
    {
        path: "/i-am",
        name: "locum_i_am",
        component: views.LocumIAM,
        meta: {
            requiresNotAuth: true,
        },
    },
    {
        path: "/work-type",
        name: "locum_work_type",
        component: views.LocumWorkType,
        meta: {
            requiresNotAuth: true,
        },
    },
    ...withPrefix("/auth", [
        {
            path: "",
            name: "get_start_one",
            component: () => import("@/views/GetStart/GetStart.vue"),
            meta: {
                requiresNotAuth: true,
            },
            beforeEnter(to, from, next) {
                console.log("🚀 ~ beforeEnter ~ from:", from)
                
                if (store.getters.GET_USER_DATA.email === null) {
                    next();
                }else{
                    next({
                        name: "auth",
                    });
                    
                }
            },
        },
        {
            path: "",
            name: "auth",
            component: () => import("@/views/Auth/Auth.vue"),
            meta: {
                requiresNotAuth: true,
            },
        },
        {
            path: "/password",
            name: "auth_password",
            component: () => import("@/views/Auth/Password/Password.vue"),
            meta: {
                requiresNotAuth: true,
            },
            beforeEnter(to, from, next) {

                if (!store.getters.GET_USER_DATA.email || !from.name) {
                    next({
                        name: "auth",
                    });
                } else if (from.name == "welcome") {
                    to.params = {
                        actionType: "setPassword",
                    };
                    next();
                } else if (from.name == "locum_i_am") {
                    to.params = {
                        actionType: "setPassword",
                    };
                    next();
                } else if (from.name == "locum_work_type") {
                    to.params = {
                        actionType: "setPassword",
                    };
                    next();
                } else if (from.name == "auth" || from.name == "password_new") {
                    to.params = {
                        actionType: "inputPassword",
                    };
                    next();
                } else {

                    (async () => {
                        try {
                            const authType = await store.dispatch("CHECK_USER_EXIST", {
                                login: store.getters.GET_USER_EMAIL,
                            });
                            to.params = {
                                authType: authType ? "inputPassword" : "setPassword",
                            };
                            next();
                        } catch (error) {
                            throw error.response.data;
                        }
                    })();
                }
            },
        },
        {
            path: "/verify",
            name: "auth_verify",
            component: () => import("@/views/Verify/Verify.vue"),
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                const userData = store.getters.GET_USER_DATA;
                if (!store.getters.GET_USER_EMAIL) {
                    next({
                        name: "auth",
                    });
                } else if (
                    store.getters.GET_USER_DATA.emailVerified &&
                    !store.getters.GET_USER_PHONE
                ) {
                    next({
                        name: "auth_mobile",
                    });
                } else if (
                    store.getters.GET_USER_DATA.emailVerified &&
                    store.getters.GET_USER_DATA.mobileNumber_verified
                ) {
                    if(userData.role === 'job-seeker'){
                       
                        next({
                            name: "jobseeker_auth_name",
                        });
                    }else if (userData.role === 'locum' && (userData.contractorOnboarding)) { 
                        next({
                        name: "welcome_contractor",
                        });
                    }else{
                        next({
                            name: "auth_name",
                        });
                    }
                } else {
                    next();
                }
            },
        },
        {
            path: "/email",
            name: "auth_email",
            component: views.UserEmail,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/mobile",
            name: "auth_mobile",
            component: () => import("@/views/User/Mobile/Mobile.vue"),
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                console.log("🚀 ~ beforeEnter222222 ~ userData:", userData)
                
                if (userData.role === 'locum' && (userData.isInternalLocum)) { 
                    next({
                        name: "search",
                    });
                }
               

                // if (userData.mobileNumber_verified || store.getters.isActive) {
                if (userData.mobileNumber_verified) {
                    next({
                        name: "auth_name",
                    });
                
                }else{
                    next();
                }
            },
        },
        {
            path: "/welcome-contractor",
            name: "welcome_contractor",
            component: views.UserContractorWelcome,
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                console.log("🚀 ~ beforeEnter ~ userData contractoooooor:", userData)
                // if (userData.name || store.getters.isActive) {

                if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                    if (userData.survey) {
                        // next({
                        //     name: "auth_contractor_rate",
                        // });
                        next({
                            name: "auth_internal_software_experience",
                        });

                    }
                    else {
                        next();
                    }
                } else {
                    next();
                }

            },
        },
        {
            path: "/name",
            name: "auth_name",
            component: views.UserName,
            meta: {
                requiresAuth: true,
            },
            async beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                console.log("🚀 ~ beforeEnter ~ userData333333333:", userData)
                // if (userData.name || store.getters.isActive) {
                if (userData.name) {
                    if (userData.role == "locum") {
                        next({
                            name: "auth_birthday",
                        });
                    }else if(userData.role == "job-seeker"){
                        console.log("i am not sure what is problem")
                        next({
                            name: "jobseeker_auth_address",
                        });

                    } else {
                        next({
                            name: "auth_billing_name",
                        });
                    }
                } else {
                    // if (userData.name || store.getters.isActive) {
                    if (userData.role == "pharmacy") {
                        const pharmacyTypes = store.getters.pharmacyTypes;
                        if (pharmacyTypes && pharmacyTypes.length === 0) {
                            await store.dispatch("GET_PHARMACY_TYPES");
                        }
                    }
                    next();
                }
            },
        },
        {
            path: "/community-pharmacy-information",
            name: "community_pharmacy_information",
            component: views.CommunityPharmacyInformation,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            async beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;

                if(userData.customFields?.communityPharmacyAdditionalInfo?.length > 0){
                    next({
                        name: "intro",
                    });
                } else  {
                    if (userData.role == "pharmacy") {
                        await store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS");
                    }
                    next();
                }
            },
        },
        {
            path: "/hospital-pharmacy-information-1",
            name: "hospital_pharmacy_information_1",
            component: views.HospitalPharmacySoftware,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            async beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.role == "pharmacy") {
                    await store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS");
                }
                if(userData.customFields?.hospitalPharmacy1AdditionalInfo?.length > 0){
                    next({
                        name: "hospital_pharmacy_information_2",
                    });

                }
                next();
            },
        },
        {
            path: "/hospital-pharmacy-information-2",
            name: "hospital_pharmacy_information_2",
            component: views.HospitalPharmacyDispensingCabinet,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            async beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.role == "pharmacy") {
                    const pharmacyAdditionalInfo = store.getters.pharmacyAdditionalInfo;
                    if (pharmacyAdditionalInfo && pharmacyAdditionalInfo.length === 0) {
                        await store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS");
                    }
                }

                if(userData.customFields?.hospitalPharmacy2AdditionalInfo?.length > 0){
                    next({ name: 'home' });
                  

                }
                next();
            },
        },
        // {
        //     path: "/job-seeker-name",
        //     name: "jobseeker_auth_name",
        //     component: views.JobseekerUserName,
        //     meta: {
        //         requiresAuth: true,
        //     },
        //     // beforeEnter(to, from, next) {
        //     //     let userData = store.getters.GET_USER_DATA;
        //     //     // if (userData.name || store.getters.isActive) {
        //     //         if (userData.name) {
        //     //             next({
        //     //                 name: "jobseeker_auth_address",
        //     //             });
        //     //         } else {
        //     //             next();
        //     //         }
                        
        //     //         }
        // },
        {
            path: "/job-seeker-address",
            name: "jobseeker_auth_address",
            component: views.JobseekerAddress,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                console.log("name enters 1");
                let userData = store.getters.GET_USER_DATA;
                console.log("🚀 ~ beforeEnter323 ~ userData:", userData)
                // if (userData.name) {
                //     next();
                // }
                // if (userData.name || store.getters.isActive) {
                if (userData.address != null) {
                    next({
                        name: "jobseeker_auth_level",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/job-seeker-level",
            name: "jobseeker_auth_level",
            component: views.JobseekerLevel,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "jobseeker_auth_address",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                const isAustralia = isAustraliaRegion();
                console.log("🚀 ~ beforeEnter ~ isAustralia:", isAustralia)
                console.log("🚀 ~ beforeEnter ~ userData:", userData)
                let hourlyRate = userData.salaryExpectationHourly ? userData.salaryExpectationHourly : 0;
                let AnnualRate = userData.salaryExpectationAnnually ? userData.salaryExpectationAnnually : 0;
                // if (userData.name || store.getters.isActive) {
                    if (hourlyRate > 0 || AnnualRate > 0) {
                        // if(isAustralia.value){
                        //     next({
                        //         name: "jobseeker_auth_cv",
                        //     });
                        // }else{
                        //     next({
                        //         name: "jobseeker_auth_software_experience",
                        //     });
                        // }
                        next({
                            name: "jobseeker_auth_software_experience",
                        });
                       
                    } else {
                        next();
                    }
            },
        },
        // {
        //     path: "/job-seeker-experience",
        //     name: "jobseeker_auth_experience",
        //     component: views.JobseekerExperience,
        //     meta: {
        //         requiresAuth: true,
        //         requiresAccountType: {
        //             redirect: "jobseeker_auth_level",
        //             type: "job-seeker",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         console.log("name enters 3");
        //         // if (userData.name || store.getters.isActive) {
        //             if (userData.yearExperienceId) {
        //                 next({
        //                     name: "jobseeker_auth_categories",
        //                 });
        //             } else {
        //                 next();
        //             }
        //     },
        // },
        // {
        //     path: "/job-seeker-categories",
        //     name: "jobseeker_auth_categories",
        //     component: views.JobseekerCategories,
        //     meta: {
        //         requiresAuth: true,
        //         requiresAccountType: {
        //             redirect: "jobseeker_auth_experience",
        //             type: "job-seeker",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         // if (userData.name || store.getters.isActive) {
        //             let categories = userData.categoryLevelIds ? userData.categoryLevelIds : [];
                   
        //             if (categories.length > 0) {
        //                 next({
        //                     name: "jobseeker_auth_rate",
        //                 });
        //             } else {
        //                 next();
        //             }
        //     },
        // },
        // {
        //     path: "/job-seeker-rate",
        //     name: "jobseeker_auth_rate",
        //     component: views.JobseekerRate,
        //     meta: {
        //         requiresAuth: true,
        //         requiresAccountType: {
        //             redirect: "jobseeker_auth_categories",
        //             type: "job-seeker",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         // if (userData.name || store.getters.isActive) {
        //             let hourlyRate = userData.salaryExpectationHourly ? userData.salaryExpectationHourly : 0;
        //             let AnnualRate = userData.salaryExpectationAnnually ? userData.salaryExpectationAnnually : 0;

        //             console.log("name enters 5");
        //             if (hourlyRate > 0 && AnnualRate > 0) {
        //                 next({
        //                     name: "jobseeker_auth_cv",
        //                 });
        //             } else {
        //                 next();
        //             }
        //     },
        // },
        {
            path: "/job-seeker-software-experience",
            component: views.SeekerSoftwareExperience,
            name: "jobseeker_auth_software_experience",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                console.log("🚀 ~ beforeEnter ~ next:", next)
                console.log("🚀 ~ beforeEnter ~ from:", from)
                console.log("🚀 ~ beforeEnter ~ to:", to)
                let userData = store.getters.GET_USER_DATA;
                console.log("🚀 ~ beforeEnter ~ userData:", userData)
                if (userData.customFields?.softwareExperience?.length > 0) {
                    next({
                        name: "jobseeker_auth_pharmacy_experience",
                    });
                } else {
                    next();
                }
            },
        },   
        {
            path: "/job-seeker-pharmacy-experience",
            component: views.SeekerPharmacyExperience,
            name: "jobseeker_auth_pharmacy_experience",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.customFields?.certificates?.length > 0) {
                    if(userData.platformRoleSlug == 'intern-pharmacist'){
                        next({
                            name: "jobseeker_auth_university",
                        });
                    }else{
                        next({
                            name: "jobseeker_auth_cv",
                        });
                    }

                } else {
                    next();
                }
            },
        },
        {
            path: "/job-seeker-university",
            component: views.SeekerUniversities,
            name: "jobseeker_auth_university",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.customFields?.universities?.length > 0) {
                    if(userData.platformRoleSlug == 'intern-pharmacist'){
                        next({
                            name: "jobseeker_auth_registration",
                        });
                    }else{
                        next({
                            name: "jobseeker_auth_cv",
                        });
                    }
                    
                } else {
                    next();
                }
            },
        },
        {
            path: "/job-seeker-registration-year",
            component: views.SeekerRegistrationYear,
            name: "jobseeker_auth_registration",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                let platformRole = store.getters.GET_USER_PLATFORM_ROLE;
                console.log("🚀 ~ beforeEnter ~ to:", platformRole);
                console.log("🚀 ~ beforeEnter ~ userData:", userData.platformRoleId)
                if (userData.customFields?.universities?.length > 0) {
                    next({
                        name: "jobseeker_auth_cv",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/job-seeker-cv",
            name: "jobseeker_auth_cv",
            component: views.JobseekerCv,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "jobseeker_auth_rate",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                    
                    let locumCvs = userData.locumCvs ? userData.locumCvs : [];

                    if (locumCvs.length > 0 || userData.survey) {
                        next({
                            name: "jobseeker_auth_enhance",
                        });
                    } else {
                        next();
                    }
            },
        },
        {
            path: "/job-seeker-photo",
            name: "jobseeker_auth_photo",
            component: views.JobseekerPhoto,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "jobseeker_auth_cv",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                    console.log("name enters 7");
                    if (userData.image || userData.survey) {
                        next({
                            name: "jobseeker_auth_enhance",
                        });
                    } else {
                        next();
                    }
            },
        },
        {
            path: "/job-seeker-enhance",
            name: "jobseeker_auth_enhance",
            component: views.JobseekerEnhance,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "jobseeker_auth_photo",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                    console.log("name enters 9");
                    // 
                    if (userData.enhanceProfile) {
                        next({
                            name: "jobseeker_auth_preview",
                        });
                    } else {
                        next();
                    }
            },
        },
        {
            path: "/job-seeker-preview",
            name: "jobseeker_auth_preview",
            component: views.JobseekerPreview,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "jobseeker_auth_enhance",
                    type: "job-seeker",
                },
            },
            beforeEnter(to, from, next) {
                
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                    console.log("name enters 10");
                    
                    if (userData.previewPublish) {
                        next({
                            name: "job_seeker_index",
                        });
                    } else {
                        next();
                    }
            },
        },
        // {
        //     path: "/job-seeker-complete",
        //     name: "jobseeker_auth_complete",
        //     component: views.JobseekerComplete,
        //     meta: {
        //         requiresAuth: true,
        //         requiresAccountType: {
        //             redirect: "jobseeker_auth_preview",
        //             type: "job-seeker",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         // if (userData.name || store.getters.isActive) {
        //             console.log("name enters 11");
        //             if (userData.survey) {
        //                 next({
        //                     name: "job_seeker_index",
        //                 });
        //             } else {
        //                 (async () => {
        //                     try {
        //                         next();
        //                     } catch (error) {
        //                         console.log(error);
        //                     }
        //                 })();
        //             }
        //     },
        // },
        {
            path: "/billing-name",
            name: "auth_billing_name",
            component: views.UserName,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                const isPharmacyWithParentId1 = employerType(userData).isCommunityPharmacy;
                // if (userData.name || store.getters.isActive) {
                if (userData.name) {
                    if(isPharmacyWithParentId1){
                        next({
                            name: "additional_name",
                        });
                    }else{
                        next({
                            name: "employer_additional_information",
                        });
                    }
                  
                } else {
                    next();
                }
            },
        },
        {
            path: "/birthday",
            component: views.UserBirthday,
            name: "auth_birthday",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.birthday || store.getters.isActive) {
                if (userData.birthday) {
                    next({
                        name: "auth_ahpra",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/gender",
            component: views.UserGender,
            name: "auth_gender",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_birthday",
                    type: "locum",
                },
            },
            // TODO: Add before enter check
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.birthday || store.getters.isActive) {
                if (userData.gender) {
                    next({
                        name: "auth_ahpra",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/employer-additional-information",
            name: "employer_additional_information",
            component: views.EmployerAdditionalInformation,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if(userData.site.parentId !== 1){
                    if (
                        (userData.additionalName1 && userData.additionalPhone1) ||
                        (userData.additionalName2 && userData.additionalPhone2)
                    ) {
                        next({
                            name: "auth_address",
                        });
                    } else {
                        next();
                    }
                }
                
                next();
            },
        },
        {
            path: "/abn",
            name: "auth_abn",
            component: views.UserAbn,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (userData.abn) {
                    next({
                        name: "auth_address",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/additional",
            name: "additional_name",
            component: views.AdditionalName,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "pharmacy",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                
                if (
                    (userData.additionalName1 && userData.additionalPhone1) ||
                    (userData.additionalName2 && userData.additionalPhone2)
                ) {
                    next({
                        name: "auth_address",
                    });
                } else {
                    next();
                }
                next();
            },
        },
        {
            path: "/ahpra",
            component: views.UserAhpra,
            name: "auth_ahpra",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_birthday",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if ((userData.ahpra.number && userData.ahpra.date) || store.getters.isActive) {
                if (userData.ahpra.number && userData.ahpra.date) {
                    next({
                        name: "auth_address",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/contractor-rate",
            component: views.UserContractorRate,
            name: "auth_contractor_rate",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.address.text || store.getters.isActive) {

                if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                    if (userData.minRate && userData.weekendRate) {
                        next({
                            name: "auth_address",
                        });

                    }
                    else {
                        next();
                    }
                } else {
                    next();
                }
            },
        },
        {
            path: "/address",
            component: views.UserAddress,
            name: "auth_address",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                const isPharmacyWithParentId1 = employerType(userData).isCommunityPharmacy;
                
                // if (userData.address.text || store.getters.isActive) {
                if (userData.address.lat) {
                    if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                        next({
                            name: "auth_business",
                        });
                    }else if(userData.role == "locum") {
                        next({
                            name: "auth_business",
                        });
                    } else {
                        if(isPharmacyWithParentId1){
                            next({
                                name: "auth_billingAddress",
                            });
                        }else{
                            if(employerType(userData).isHospitalPharmacy){
                                next({
                                    name: "hospital_pharmacy_information_1",
                                });
                            }else{
                                next({name:'home'});
                            }
                        }
                    }
                } else {
                   
                        next();
                    
                }
            },
        },
        {
            path: "/billing-address",
            component: views.UserAddress,
            name: "auth_billingAddress",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.billing.address.text || store.getters.isActive) {
                if (userData.billing.address.text) {
                    next({
                        name: "auth_gallery",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/business",
            component: views.UserBusiness,
            name: 'auth_business',
            meta: {
                requiresAuth: true,
            },
            async beforeEnter(to, from, next) {
                await store.dispatch("SET_CURRENT_USER_DATA", {
                    with:
                        "billingInfo,superRecord",
                })
                let userData = store.getters.GET_USER_DATA;
                if (userData.abn && userData.billing.businessName && userData.billing.type) {
                    next({
                        name: "auth_bank",
                    });
                }
                
                next();
            }
        },
                {
            path: "/bank",
            component: views.UserBank,
            name: 'auth_bank',
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.billing.bankAccountName &&
                    userData.billing.bankAccountNumber &&
                    userData.billing.bankBsb &&
                    userData.billing.bankNameBilling) {
                    // store.dispatch("SET_CURRENT_USER_DATA", {
                    //     with:
                    //         "billingInfo",
                    // });

                    if(userData.role === 'locum' && userData.billing.type === 2){
                        next({
                            name: "auth_super",
                        });
                    }else{
                        next({
                            name: "auth_gst",
                        });
                    }
                   

                   
                }else{
                    next();
                }
                
            }
        },
        {
            path: "/payout",
            component: views.UserPayout,
            name: "auth_payout",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                console.log("all user data", userData);
                // if ((userData.billing.bankAccountName && userData.billing.bankAccountNumber && userData.billing.bankBsb && userData.billing.name && userData.abn) || store.getters.isActive) {
                if (
                    userData.billing.bankAccountName &&
                    userData.billing.bankAccountNumber &&
                    userData.billing.bankBsb &&
                    userData.billing.bankNameBilling &&
                    userData.abn && userData.billing.businessName && userData.billing.type
                ) {
                    store.dispatch("SET_CURRENT_USER_DATA", {
                        with:
                            "billingInfo",
                    });


                    if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                        if (userData.billing.type === 2) {
                            next({
                                name: "auth_super",
                            });
                        } else {
                            next({
                                name: "auth_gst",
                            });
                        }

                    } else {

                        next({
                            name: "auth_travel",
                        });
                    }

                } else {
                    if (userData.role === 'locum' && (userData.contractorOnboarding) && userData.survey) {
                        if (userData.billing.type === 2) {
                            next({
                                name: "auth_super",
                            });
                        } else {
                            next({
                                name: "auth_gst",
                            });
                        }
                    } else {

                        next();
                    }
                }
            },
        },
        {
            path: "/photo",
            component: views.UserPhoto,
            name: "auth_photo",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.image || store.getters.isActive) {
                if (userData.image) {
                    if (userData.role == "locum") {
                        next({
                            name: "auth_travel",
                        });
                    } else {
                        next({
                            name: "auth_gallery",
                        });
                    }
                } else {
                    next();
                }
            },
        },
        {
            path: "/gallery",
            name: "auth_gallery",
            component: views.UserGallery,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "home",
                    type: "pharmacy",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.survey) {
                    next({
                        name: "auth_workEnvironment",
                    });
                } else {
                    (async () => {
                        try {
                            const resp = await store.dispatch("GET_USER_GALLERY");
                            to.params.files = resp.data;
                            if (resp.data.length > 0) {
                                next({
                                    name: "auth_workEnvironment",
                                });
                            } else {

                                next();
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        {
            path: "/work-environment",
            component: views.UserWorkEnvironment,
            name: "auth_workEnvironment",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "photo",
                    type: "pharmacy",
                },
            },
            async beforeEnter(to, from, next) {
                await store.dispatch("SET_CURRENT_USER_DATA", {
                    with:
                        "settings,billingInfo,schedule,address,push_notifications,config.hours_before_shift_lock",
                })
                let userData = store.getters.GET_USER_DATA;
                if (
                    userData.environment.scriptsPerDay &&
                    userData.environment.software &&
                    userData.environment.services.length &&
                    userData.averageScriptsSaturdayId &&
                    userData.averageScriptsSundayId
                ) {
                    next({
                        name: "intro",
                    });
                } else {
                    try {
                        await Promise.all([
                            store.dispatch("GET_PHARMACY_SERVICES"),
                            store.dispatch("GET_PHARMACY_SOFTWARE"),
                            store.dispatch("GET_PHARMACY_SCRIPTS_COUNT"),
                        ]);
                        next();
                    } catch (error) {
                        console.log(error);
                    }
                }
            },
        },
        {
            path: "/gst",
            name: "auth_gst",
            component: views.UserGst,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                    if (userData.gst) {
                        next({
                            name: "identity_document",
                        });
                    } else {
                        next();
                    }
                } else {
                    if (userData.gst !== null) {
                        next({
                            name: "auth_travel",
                        });
                    } else {
                        next();
                    }
                }

            },
        },
        {
            path: "/super",
            name: "auth_super",
            component: views.UserSuper,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.superEnable === 1 && userData.superRecord.bsb !== null) {
                    if (userData.role === 'locum' ) {
                        next({
                            name: "auth_travel",
                        });
                    } else {
                        next();
                    }

                } else {
                    next();
                }
            },
            // TODO: BEFORE ENTER
            // beforeEnter(to, from, next) {
            // COUNT USER ENTITY if !SOLE TRADER THEN SKIP
            //     let userData = store.getters.GET_USER_DATA;
            //     // if ((userData.billing.bankAccountName && userData.billing.bankAccountNumber && userData.billing.bankBsb && userData.billing.name && userData.abn) || store.getters.isActive) {
            //     if (
            //         userData.billing.bankAccountName &&
            //         userData.billing.bankAccountNumber &&
            //         userData.billing.bankBsb &&
            //         userData.billing.name &&
            //         userData.abn
            //     ) {
            //         next({
            //             name: "auth_photo",
            //         });
            //     } else {
            //         next();
            //     }
            // },
        },
        {
            path: "/travel",
            name: "auth_travel",
            component: views.UserTravel,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;

                const isAllNull = Object.values(userData.travel).every(value => value === null);
                // if (userData.name || store.getters.isActive) {
                if (!isAllNull) {
                    next({
                        name: "auth_languages",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/languages",
            name: "auth_languages",
            component: views.UserLanguages,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if (userData.settings?.languages?.length > 0) {
                    next({
                        name: "identity_document",
                    });
                } else {
                    (async () => {
                        try {
                            await store.dispatch("GET_LANGUAGES_LIST");
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        {
            path: "/identity-document",
            name: "identity_document",
            component: views.IdentityDocuments,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.identityDocument?.length > 0) {
                    next({
                        name: "insurance_document",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        {
            path: "/insurance-document",
            name: "insurance_document",
            component: views.InsuranceDocuments,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            async beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {

                if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                    if (userData.insuranceDocument?.length > 0) {

                        // Insurance document is last screen for contractor onboarding, 
                        // to be safe side if contactor onboarding is not set to false (contractor onboarding is completed) then we do it from here
                        await store.dispatch("SAVE_USER_DATA", {
                            survey: 1,
                            hideLoading: true,
                        });
                        await store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");

                        next({
                            name: "intro",
                        });
                    } else {
                        next();
                    }

                } else if (userData.insuranceDocument?.length > 0) {
                    next({
                        name: "cv_upload",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        /* Add CV */
        {
            path: "/cv-upload",
            name: "cv_upload",
            component: views.Cv,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.locumCvs?.length > 0) {
                    next({
                        name: "experience_overview",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        {
            path: "/experience-overview",
            name: "experience_overview",
            component: views.LocumExperienceOverview,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.settings?.yearExperienceId) {
                    next({
                        name: "auth_software_experience",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        {
            path: "/software-experience",
            component: views.UserSoftwareExperience,
            name: "auth_software_experience",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if(userData.customFields && userData.customFields.softwareExperience) {
                    next({
                        name: "auth_pharmacist_certifications",
                    });
                } else {
                    next();
                }
            },
        },    
        {
            path: "/pharmacist-certifications",
            component: views.UserPharmacistCertification,
            name: "auth_pharmacist_certifications",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if(userData.customFields && userData.customFields.certificates) {
                    next({
                        name: "auth_availability_week",
                    });
                } else {
                    next();
                }
            },
        },


        {
            path: "/internal/software-experience",
            component: views.UserSoftwareExperience,
            name: "auth_internal_software_experience",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if(userData.customFields && userData.customFields.softwareExperience) {
                    next({
                        name: "auth_internal_pharmacist_certifications",
                    });
                } else {
                    next();
                }
            },
        },    
        {
            path: "/internal/pharmacist-certifications",
            component: views.UserPharmacistCertification,
            name: "auth_internal_pharmacist_certifications",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                if(userData.customFields && userData.customFields.certificates) {
                    next({
                        name: "auth_contractor_rate",
                    });
                } else {
                    next();
                }
            },
        },



        {
            path: "/availability/week",
            name: "auth_availability_week",
            component: views.UserAvailable,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (Object.values(userData.schedule).includes(1)) {
                    next({
                        name: "auth_preferred_state",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/preferred-state",
            name: "auth_preferred_state",
            component: views.PreferredState,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (userData.settings?.preferredStates && userData.intro === 1) {
                    next({
                        name: "auth_availability_shift_type",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/availability/shift-type",
            name: "auth_availability_shift_type",
            component: views.UserAvailableShiftType,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (Object.values(userData.shiftType).includes(1)) {
                    next({
                        name: "auth_rate",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/availability/rate",
            name: "auth_rate",
            component: views.UserRate,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (userData.minRate) {
                    next({
                        name: "auth_travel_preferences",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/travel/preferences",
            name: "auth_travel_preferences",
            component: views.TravelPreferences,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (userData.travelPreference !== null) {
                    next({
                        name: "auth_travel_preferences_assignment",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/travel/preferences/assignment",
            name: "auth_travel_preferences_assignment",
            component: views.TravelPreferencesAssignment,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.abn || store.getters.isActive) {
                if (userData.travelAssignment !== null) {
                    next({
                        name: "covid_status",
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: "/covid-status",
            name: "covid_status",
            component: views.CovidStatus,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },

            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.survey) {
                    next({
                        name: "personal_cert",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        // {
        //     path: "/covid-cert",
        //     name: "covid_cert",
        //     component: views.CovidCerf,
        //     meta: {
        //         requiresAuth: false,
        //         requiresAccountType: {
        //             redirect: "auth_name",
        //             type: "locum",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         // if (userData.name || store.getters.isActive) {
        //         if (userData.survey) {
        //             next({
        //                 name: "personal_cert",
        //             });
        //         } else {
        //             (async () => {
        //                 try {
        //                     next();
        //                 } catch (error) {
        //                     console.log(error);
        //                 }
        //             })();
        //         }
        //     },
        // },
        {
            path: "/personal-cert",
            name: "personal_cert",
            component: views.PersonalCert,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "auth_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
                if (userData.survey) {
                    next({
                        name: "intro",
                    });
                } else {
                    (async () => {
                        try {
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                }
            },
        },
        // {
        //     path: "/stripe-connect",
        //     name: "stripe_connect",
        //     component: views.StripeConnect,
        //     meta: {
        //         requiresAuth: false,
        //         requiresAccountType: {
        //             redirect: "auth_name",
        //             type: "locum",
        //         },
        //     },
        //     beforeEnter(to, from, next) {
        //         let userData = store.getters.GET_USER_DATA;
        //         // if (userData.name || store.getters.isActive) {
        //         if (userData.survey) {
        //             next({
        //                 name: "intro",
        //             });
        //         } else {
        //             (async () => {
        //                 try {
        //                     next();
        //                 } catch (error) {
        //                     console.log(error);
        //                 }
        //             })();
        //         }
        //     },
        // },
    ]),
    ...withPrefix("/onboard", [
        {
            path: "/name",
            name: "onboard_name",
            component: views.InternalPoolName,
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // if (userData.name || store.getters.isActive) {
             
                    next();
                
            },
        },
        {
            path: "/birthday",
            component: views.InternalPoolBirthday,
            name: "onboard_birthday",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.birthday || store.getters.isActive) {
                // if (userData.birthday) {
                //     next({
                //         name: "onboard_gender",
                //     });
                // } else {
                //     next();
                // }
                next();
            },
        },
        {
            path: "/gender",
            component: views.InternalPoolGender,
            name: "onboard_gender",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_birthday",
                    type: "locum",
                },
            },
            // TODO: Add before enter check
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.birthday || store.getters.isActive) {
                // if (userData.gender) {
                //     next({
                //         name: "onboard_ahpra",
                //     });
                // } else {
                //     next();
                // }

                next();
            },
        },
        {
            path: "/ahpra",
            component: views.InternalPoolAhpra,
            name: "onboard_ahpra",
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_birthday",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if ((userData.ahpra.number && userData.ahpra.date) || store.getters.isActive) {
                // if (userData.ahpra.number && userData.ahpra.date) {
                //     next({
                //         name: "onboard_address",
                //     });
                // } else {
                //     next();
                // }

                next();
            },
        },
        {
            path: "/address",
            component: views.InternalPoolAddress,
            name: "onboard_address",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.address.text || store.getters.isActive) {
                // if (userData.address.lat) {
                //     if (userData.role == "locum") {
                //         next({
                //             name: "onboard_payout",
                //         });
                //     } 
                // } else {
                //     next();
                // }
                next();
            },
        },
        {
            path: "/payout",
            component: views.InternalPoolPayout,
            name: "onboard_payout",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {


               


                let userData = store.getters.GET_USER_DATA;
                console.log("all user data",userData);
                // if ((userData.billing.bankAccountName && userData.billing.bankAccountNumber && userData.billing.bankBsb && userData.billing.name && userData.abn) || store.getters.isActive) {
                if (
                    userData.billing.bankAccountName &&
                    userData.billing.bankAccountNumber &&
                    userData.billing.bankBsb &&
                    userData.billing.bankNameBilling &&
                    userData.abn && userData.billing.businessName && userData.billing.type
                ) {
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "billingInfo",
                            });

                            if (userData.billing.type === 2) {
                                next({
                                    name: "onboard_super",
                                });
                            } else {
                                next({
                                    name: "onboard_gst",
                                });
                            }
                } else {
                    next();
                }
            },
        },
        {
            path: "/super",
            name: "onboard_super",
            component: views.InternalPoolSuper,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            // TODO: BEFORE ENTER
            beforeEnter(to, from, next) {
                // COUNT USER ENTITY if !SOLE TRADER THEN SKIP
                    // let userData = store.getters.GET_USER_DATA;
                    // // if ((userData.billing.bankAccountName && userData.billing.bankAccountNumber && userData.billing.bankBsb && userData.billing.name && userData.abn) || store.getters.isActive) {
                    // if (
                    //     userData.survey) {
                    //     next({
                    //         name: "onboard_gst",
                    //     });
                    // } else {
                    //     next();
                    // }
                    next();
                },
        },
        {
            path: "/gst",
            name: "onboard_gst",
            component: views.InternalPoolGst,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_travel",
                //     });
                // } else {
                //     next();
                // }
                next();
            },
        },
        {
            path: "/travel",
            name: "onboard_travel",
            component: views.InternalPoolTravel,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_languages",
                //     });
                // } else {
                //     next();
                // }
                next();
            },
        },
        {
            path: "/languages",
            name: "onboard_languages",
            component: views.InternalPoolLanguages,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                //     if (userData.survey) {
                //         next({
                //             name: "onboard_photo",
                //         });
                //     } else {
                //         (async () => {
                //             try {
                //                 await store.dispatch("GET_LANGUAGES_LIST");
                //                 next();
                //             } catch (error) {
                //                 console.log(error);
                //             }
                //         })();
                //     }
                (async () => {
                            try {
                                await store.dispatch("GET_LANGUAGES_LIST");
                                next();
                            } catch (error) {
                                console.log(error);
                            }
                        })();
            },
        },
        {
            path: "/photo",
            component: views.InternalPoolPhoto,
            name: "onboard_photo",
            meta: {
                requiresAuth: true,
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.image || store.getters.isActive) {
                // if (userData.image) {
                //     if (userData.role == "locum") {
                //         next({
                //             name: "onboard_identity_document",
                //         });
                //     } 
                // } else {
                //     next();
                // }
                next();
            },
        },
        {
            path: "/identity-document",
            name: "onboard_identity_document",
            component: views.InternalPoolIdentityDocuments,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_insurance_document",
                //     });
                // } else {
                //     (async () => {
                //         try {
                //             next();
                //         } catch (error) {
                //             console.log(error);
                //         }
                //     })();
                // }
                next();
            },
        },
        {
            path: "/insurance-document",
            name: "onboard_insurance_document",
            component: views.InternalPoolInsuranceDocuments,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_cv_upload",
                //     });
                // } else {
                //     (async () => {
                //         try {
                //             next();
                //         } catch (error) {
                //             console.log(error);
                //         }
                //     })();
                // }
                next();
            },
        },
        {
            path: "/cv-upload",
            name: "onboard_cv_upload",
            component: views.InternalPoolCv,
            meta: {
                requiresAuth: true,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },   
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_covid_status",
                //     });
                // } else {
                //     (async () => {
                //         try {
                //             next();
                //         } catch (error) {
                //             console.log(error);
                //         }
                //     })();
                // }
                next();
            },
        },
        {
            path: "/covid-status",
            name: "onboard_covid_status",
            component: views.InternalPoolCovidStatus,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_personal_cert",
                //     });
                // } else {
                //     (async () => {
                //         try {
                //             next();
                //         } catch (error) {
                //             console.log(error);
                //         }
                //     })();
                // }
                next();
            },
        },
        {
            path: "/personal-cert",
            name: "onboard_personal_cert",
            component: views.InternalPoolPersonalCert,
            meta: {
                requiresAuth: false,
                requiresAccountType: {
                    redirect: "onboard_name",
                    type: "locum",
                },
            },
            beforeEnter(to, from, next) {
                // let userData = store.getters.GET_USER_DATA;
                // // if (userData.name || store.getters.isActive) {
                // if (userData.survey) {
                //     next({
                //         name: "onboard_intro",
                //     });
                // } else {
                //     (async () => {
                //         try {
                //             next();
                //         } catch (error) {
                //             console.log(error);
                //         }
                //     })();
                // }
                next();
            },
        },
        
    ]),

    {
        path: "/job-create",
        name: "job_create",
        component: views.JobCreate,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            const userData = store.getters.GET_USER_DATA;
            if (!userData.active) {
                ElMessage({
                    type: "error",
                    message: "Your account is not active. You cannot create a job.",
                });
                next({ name: "home" });
                return;
            }
            if (to.name == "job_create" || !to.name) {
                next({
                    name: "job_create_date",
                });
            } else {
                next();
            }
        },
        children: [

            {
                path: "visibility",
                name: "job_visibilty",
                component: () => import("@/views/Job/Create/Visibility/Visibility.vue"),

            },

            {
                path: "date",
                name: "job_create_date",
                // component: views.JobCreateDate,
                component: () => import("@/views/Job/Create/Date/Date.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            const shifts = await store.dispatch("GET_SHIFT_LIST", {
                                start_date: moment().format("YYYY-MM-DD"),
                                per_page: 200,
                                navigation: 'shift_create_calendar'
                            });
                            store.dispatch("setJobCreatePageData", {
                                shifts: shifts.data,
                            });
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
            {
                path: "shift_visibility",
                name: "shift_visibility",
                component: views.ShiftVisibility,
                beforeEnter(to, from, next) {
                    if (process.env.VUE_APP_ENABLE_SHIFT_VISIBILITY === "false") {
                        next({
                            name: "job_create_date",
                        });
                    } else {
                        next();
                    }
                },

            },
             {
                path: "multiple_shift_visibility",
                name: "multiple_shift_visibility",
                component: views.MultipleShiftVisibility,
                beforeEnter(to, from, next) {
                    if (process.env.VUE_APP_ENABLE_SHIFT_VISIBILITY === "false") {
                        next({
                            name: "job_create_date",
                        });
                    } else {
                        next();
                    }
                },

            },
            {
                path: "schedule",
                name: "job_create_schedule",
                component: views.JobCreateSchedule,
            },
            {
                path: "shift-access",
                name: "job_shift_access",
                component: views.JobShiftAccess,
            },
            {
                path: "rate",
                name: "job_create_rate",
                component: views.JobCreateRate,
            },
            {
                path: "additional_information",
                name: "additional_information",
                component: views.JobCreateAdditional,
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            await store.dispatch("GET_LANGUAGES_LIST");
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
        ],
    },
    {
        path: "/create-job-listing",
        name: "create_job_listing",
        component: views.JobListingCreate,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            if (to.name == "create_job_listing" || !to.name) {
                next({
                    name: "job_create_listing",
                });
            } else {
                next();
            }
        },
        children: [
          
            {
                path: "job-create-listing",
                name: "job_create_listing",
                component: views.JobListingLinsting,
               
            },
            {
                path: "job-rate-listing",
                name: "job_rate_listing",
                component: views.JobListingRate,
               
            },  
            {
                path: "job-description-listing",
                name: "job_description_listing",
                component: views.JobListingDescription,
               
            },  
            {
                path: "job-question-listing",
                name: "job_question_listing",
                component: views.JobListingQuestion,
               
            },   
            {
                path: "job-subscription-listing",
                name: "job_subscription_listing",
                component: views.JobLisitingSubscription,
               
            },
            {
                path: "job-listing-payment",
                name: "job_lisiting_payment",
                component: views.JobLisitingPayment,
               
            }, 
            {
                path: "job-listing-payment-completed",
                name: "job_lisiting_payment_completed",
                component: views.JobLisitingPaymentCompleted,
               
            },          
        ],
    },

    {
        path: "/create-guest-shift",
        name: "create_guest_shift",
        component: views.CreateGuestShift,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            if (to.name == "create_guest_shift" || !to.name) {
                next({
                    name: "create_guest_shift_date",
                });
            } else {
                next();
            }
        },
        children: [
            {
                path: "guest_shift_date",
                name: "create_guest_shift_date",
                // component: views.JobCreateDate,
                component: () => import("@/views/GuestShift/Create/Date/Date.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            const shifts = await store.dispatch("GET_SHIFT_LIST", {
                                start_date: moment().format("YYYY-MM-DD"),
                                per_page: 100,
                            });
                            store.dispatch("setGuestShiftRecordCreatePageData", {
                                shifts: shifts.data,
                            });
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
            {
                path: "guest_shift_schedule",
                name: "create_guest_shift_schedule",
                component: views.CreateGuestShiftSchedule,
            },
            {
                path: "guest_shift_rate",
                name: "create_guest_shift_rate",
                component: views.CreateGuestShiftRate,
            },
            {
                path: "guest_shift_additional_information",
                name: "guest_shift_additional_information",
                component: views.CreateGuestShiftAdditional,
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            await store.dispatch("GET_GUEST_SHIFT_INITIAL");
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
        ],
    },
    {
        path: "/guest_shift_details/:shiftId",
        name: "guest_shift_details",
        component: views.GuestShiftDetails,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            console.log("jajajajajajajajajajajajajajaj", to.params.shiftId);
            (async () => {
                try {
                    const guestShift = await store.dispatch("GET_GUEST_SHIFT_DETAILS_FOR_PHARMACY", {
                        shiftId: to.params.shiftId,
                    });
                    console.log("guest shift preview data", guestShift);

                    next();
                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();
        },
    },
    {
        path: "/guest-shift/unavailable",
        name: "shift_unavailable",
        component: views.Noshift,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/guest-shift/:jobId",
        name: "guest_shift_book_days",
        component: views.GuestShiftBookDays,
        meta: {
            requiresAuth: false,
        },
        beforeEnter(to, from, next) {

            console.log("jajajajajajajajajajajajajajaj", to.params.jobId);
            (async () => {
                try {
                    const guestShift = await store.dispatch("GET_GUEST_SHIFT_INFO", {
                        jobId: to.params.jobId,
                    });
                    console.log("guest shift data", guestShift);
                    if (guestShift.verified == true) {
                        next({
                            name: "shift_unavailable",
                        });
                    } else {
                        next();
                    }
                    // store.dispatch("setGuestShiftPublic", {
                    //     guestShift: guestShift,
                    // });
                    // next();
                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
    {
        path: "/guest-shift/preview/:jobId",
        name: "guest_shift_preview_book_days",
        component: views.GuestShiftPreviewBookDays,
        meta: {
            requiresAuth: false,
        },
        beforeEnter(to, from, next) {

            console.log("jajajajajajajajajajajajajajaj", to.params.jobId);
            (async () => {
                try {
                    const guestShift = await store.dispatch("GET_PREVIEW_GUEST_SHIFT_INFO", {
                        jobId: to.params.jobId,
                    });
                    console.log("guest shift preview data", guestShift);
                    if (guestShift.verified == true) {
                        next({
                            name: "shift_unavailable",
                        });
                    } else {
                        next();
                    }
                    // store.dispatch("setGuestShiftPublic", {
                    //     guestShift: guestShift,
                    // });
                    // next();
                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
    {
        path: "/job-filters",
        component: views.JobFilters,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            let pathNames = ["job_filters_days", "job_filters_rate"];

            if (!pathNames.includes(from.name)) {
                if (from.name != undefined) {
                    store.dispatch("clearJobFiltersData");
                }
            }
            next();
        },
        children: [
            {
                path: "days",
                name: "job_filters_days",
                component: views.JobFiltersDays,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "rate",
                name: "job_filters_rate",
                component: views.JobFiltersRate,
                meta: {
                    requiresAuth: true,
                },
                beforeEnter(to, from, next) {
                    if (from.name != "job_filters_days" && from.name != undefined) {
                        next({
                            name: "job_filters_days",
                        });
                    } else {
                        next();
                    }
                },
            },
        ],
    },
    {
        path: "/job-preview/:jobId",
        name: 'job-preview',
        component: views.JobShiftsPreview,
        meta: {
            requiresAuth: false,
        },
        beforeEnter(to, from, next) {
            (async () => {
                await store.dispatch("GET_JOB_PREVIEW_INFO", {
                    jobId: to.params.jobId,
                    params: {
                        with:
                            "pharmacy,pharmacy.settings,pharmacy.address,shifts,settings",
                    }
                })
                next()
            })();


        }
    },

    {
        path: "/job-book/:jobId",
        component: views.JobShiftsBook,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            console.log('to', to.name)
            if (to.params) {
                if (to.name == "job_book_days" || to.name == "job_book_calendar" || to.name == "job_book_urgent") {
                    next();
                }
                else if (to.name == "agency_job_book_days") {
                    next();
                }
                else {
                    if (store.getters.GET_USER_DATA.role === "locum") {
                        next({
                            name: "job_book_days",
                            params: {
                                jobId: to.params.jobId,
                            },
                        });
                    }
                    else if (store.getters.GET_USER_DATA.role === 'agency') {
                        next({
                            name: "agency_job_book_days",
                            params: {
                                jobId: to.params.jobId,
                            },
                        });
                    }
                }
            } else {
                next({
                    name: "home",
                });
            }
        },

        children: [
            {
                path: "days",
                name: "job_book_days",
                component: views.JobShiftsBookDays,
                beforeEnter(to, from, next) {
                    let pathNames = ["job_book_days", "job_book_calendar", "report"];
                    if (!pathNames.includes(from.name)) {
                        if (from.name != undefined) {
                            store.dispatch("clearJobDetails");
                            store.dispatch("setPageBack", {
                                state: "job",
                                page: {
                                    name: from.name,
                                    path: to.params.path || from.path,
                                },
                            });
                        }
                    }

                    let job = store.getters.getJobDetails.job;

                    if (job && from.name !== 'job-preview') {
                        next();
                        return;
                    }

                    next();
                },
            },
            {
                path: "agency-days",
                name: "agency_job_book_days",
                component: views.AgencyShiftDays,
                beforeEnter(to, from, next) {
                    console.log(to, 'to')
                    let pathNames = ["agency_job_book_days", "job_book_calendar", "report"];
                    if (!pathNames.includes(from.name)) {
                        if (from.name != undefined) {
                            store.dispatch("clearJobDetails");
                            store.dispatch("setPageBack", {
                                state: "job",
                                page: {
                                    name: from.name,
                                    path: to.params.path || from.path,
                                },
                            });
                        }
                    }

                    next();
                },
            },
            {
                path: "calendar",
                name: "job_book_calendar",
                // component: views.JobShiftsBookCalendar,
                component: () =>
                    import("@/views/Job/Shifts/Book/Calendar/Calendar.vue"),
                beforeEnter(to, from, next) {
                    let job = store.getters.getJobDetails.job;
                    let userData = store.getters.GET_USER_DATA;
                    checkOneSignalSubscription(store);
                    if (store.getters.GET_USER_DATA.role === "job-seeker") {
                        next({
                            name: 'job_seeker_index',
                        });
                      }

                    if (
                        !job ||
                        (from.name != "job_book_days" && from.name != undefined && from.name != "agency_job_book_days")
                    ) {
                        if(userData.role == "agency"){
                            next({
                                name: "agency_job_book_days",
                                params: {
                                    jobId: to.params.jobId,
                                },
                            });

                        }else{
                            next({
                                name: "job_book_days",
                                params: {
                                    jobId: to.params.jobId,
                                },
                            });
                        }
                       
                    } else {
                        next();
                    }
                },
            },
            {
                path: "urgent",
                name: "job_book_urgent",
                component: views.JobShiftsBookUrgent,
                beforeEnter(to, from, next) {
                    console.log("iam urgent from route");
                    let pathNames = ["job_book_urgent", "job_book_calendar", "report"];
                    if (!pathNames.includes(from.name)) {
                        if (from.name != undefined) {
                            store.dispatch("clearJobDetails");
                            store.dispatch("setPageBack", {
                                state: "job",
                                page: {
                                    name: from.name,
                                    path: to.params.path || from.path,
                                },
                            });
                        }
                    }
                    next();

                    // let job = store.getters.getJobDetails.job;

                    // if (!job || from.name === 'job-preview' || (job && job.id != to.params.jobId)) {
                    //     (async () => {
                    //         try {
                    //             let job = await store.dispatch("GET_JOB_INFO", {
                    //                 jobId: to.params.jobId,
                    //                 params: {
                    //                     with:
                    //                         "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,shifts,shifts.abilities,settings,shifts.settings",
                    //                 },
                    //             });
                    //             store.dispatch("setJobDetails", {
                    //                 job: job.data,
                    //             });

                    //             next();
                    //         } catch (error) {
                    //             next({
                    //                 name: "home",
                    //             });
                    //         }
                    //     })();
                    // } else {
                    //     next();
                    // }
                },
            },
        ],
    },

    {
        path: "/job/:jobId",
        name: "job",
        component: views.Job,
        meta: {
            requiresAuth: false,
        },
        beforeEnter(to, from, next) {
            if (store.getters.GET_USER_DATA.role === "job-seeker") {
                next({
                    name: 'job_seeker_index',
                });
              }
           
            if (to.params) {
                if (
                    from.name != "job" &&
                    from.name != "job_days" &&
                    from.name != "job_calendar" &&
                    from.name != undefined
                ) {
                    const date = store.getters.getJobDetails.date;
                    store.dispatch("clearJobDetails");
                    if (date) {
                        store.dispatch("setJobDetails", {
                            date: date,
                        });
                    }
                }
                if (to.name == "job_days" || to.name == "job_calendar") {
                    console.log("main");
                    next();
                } else {


                    next({
                        name: "job_days",
                        params: {
                            jobId: to.params.jobId,
                        },
                    });
                }
            } else {
                next({
                    name: "home",
                });
            }
        },

        children: [
            {
                path: "days",
                name: "job_days",
                component: () => {
                    const userRole = store.getters.GET_USER_DATA?.role;
                    // Vue Router async component factories must return a Promise
                    if (userRole === "pharmacy") {
                        return Promise.resolve(views.PharmacyJobDays);
                    }
                    return Promise.resolve(views.JobDays);
                },
                beforeEnter(to, from, next) {
                    let pathNames = ["job", "job_days", "job_calendar"];
                    // store.dispatch("GET_LANGUAGES_LIST");
                    if (!pathNames.includes(from.name)) {
                        if (from.name == undefined) {
                            if (!store.getters["getPageBack"]("job")) {
                                store.dispatch("setPageBack", {
                                    state: "job",
                                    page: {
                                        name: from.name,
                                        // path: to.params.path || from.path,
                                    },
                                });
                            }
                        } else {
                            // store.dispatch('clearJobDetails');
                            if (to.params.date) {
                                console.log("single one");
                                store.dispatch("setJobDetails", {
                                    date: to.params.date,
                                });
                            }
                            if (to.params.userId) {
                                console.log("single two");
                                store.dispatch("setJobDetails", {
                                    userId: to.params.userId,
                                });
                            }
                            store.dispatch("setPageBack", {
                                state: "job",
                                page: {
                                    name: from.name,
                                    // path: to.params.path || from.path,
                                },
                            });
                        }
                    }

                    if (store.getters.GET_USER_DATA.role === "locum") {
                        next();
                        return;
                    }

                    (async () => {
                        try {
                            console.log('callling jobs');
                            const job = await store.dispatch("GET_JOB_INFO_DETAILS", {
                                jobId: to.params.jobId,
                                params: {
                                    with:
                                        // Locum days: light shifts only (own applications loaded in resource). Pharmacy still omits shifts via loadJobDetail.
                                        "pharmacy,pharmacy.settings,pharmacy.address,abilities,config.hours_before_shift_lock,settings,shifts,shifts.locum",
                                },
                            });
                            console.log("🚀 ~ beforeEnter ~ job:", job)
                            // Pharmacy optimized job detail may omit shifts (loaded via paginated shiftsList).
                            if (!job.data.shifts) {
                                job.data.shifts = [];
                            }
                            stampHideRecommendedRateForLocum(
                                job.data,
                                store.getters.GET_USER_DATA?.role
                            );
                            const userId = store.getters.getJobDetails.userId;
                            if (userId) {
                                job.data.shifts = job.data.shifts.filter(
                                    (shift) => shift.userId == userId
                                );
                            }
                            job.data.shifts = job.data.shifts.map((shift) => {
                                // eslint-disable-next-line no-unused-vars
                                const { pharmacy, ...rest } = shift;
                                return rest;
                            });
                            store.dispatch("setJobDetails", {
                                job: job.data,
                            });
                            next();
                        } catch (error) {
                            next({
                                name: "home",
                            });
                        }
                    })();

                },
            },
            {
                path: "calendar/:date?",
                name: "job_calendar",
                component: () => import("@/views/Job/Calendar/Calendar.vue"),
                beforeEnter(to, from, next) {
                    checkOneSignalSubscription(store);
                    if (store.getters.GET_USER_DATA.role === "job-seeker") {
                        next({
                            name: 'job_seeker_index',
                        });
                      }
                    (async () => {
                        try {
                            const job = await store.dispatch("GET_JOB_INFO", {
                                jobId: to.params.jobId,
                                params: {
                                    with:
                                        "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings",
                                    // Required for optimised pharmacy job detail to embed shifts for calendar.
                                    navigation: "job_detail_calendar",
                                },
                            });
                            if (!job.data.shifts) {
                                job.data.shifts = [];
                            }
                            stampHideRecommendedRateForLocum(
                                job.data,
                                store.getters.GET_USER_DATA?.role
                            );
                            const userId = store.getters.getJobDetails.userId;
                            if (userId) {
                                job.data.shifts = job.data.shifts.filter(
                                    (shift) => shift.userId == userId
                                );
                            }
                            store.dispatch("setJobDetails", {
                                job: job.data,
                            });
                            next();
                        } catch (error) {
                            next({
                                name: "home",
                            });
                        }
                    })();
                },
            },
        ],
    },

    {
        path: "/shift/:shiftId",
        name: "shift",
        component: views.Shift,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (to.params) {
                if (from.name == "search") {
                    store.dispatch("clearJobShiftsBookPageData");
                }
                (async () => {
                    try {
                        let resp = await store.dispatch("GET_SHIFT_INFO", {
                            shiftId: to.params.shiftId,
                            params: {
                                with:
                                    "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,abilities,locum.billingInfo",
                            },
                        });
                        to.params.shift = resp.data;
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next({
                    name: "home",
                });
            }
        },
        children: [
            {
                path: "confirm",
                name: "shift_confirm",
                component: views.ShiftConfirm,
                beforeEnter(to, from, next) {
                    const userData = store.getters.GET_USER_DATA;
                    if (
                        (to.params.shift.statusText == "completed" &&
                            userData.role == "locum") ||
                        (to.params.shift.statusText == "submitted" &&
                            userData.role == "pharmacy")
                    ) {
                        next();
                    } else
                        next({
                            name: "home",
                        });
                },
            },
            {
                path: "rating",
                name: "shift_rating",
                component: views.ShiftRating,
                beforeEnter(to, from, next) {
                    if (from.name != undefined) {
                        (async () => {
                            try {
                                let resp = await store.dispatch("GET_SHIFT_INFO", {
                                    shiftId: to.params.shiftId,
                                    params: {
                                        with: "pharmacy,locum,abilities",
                                    },
                                });
                                to.params.shift = resp.data;
                                next();
                            } catch (error) {
                                next({
                                    name: "home",
                                });
                            }
                        })();
                    } else {
                        next();
                    }
                },
            },
        ],
    },

    {
        path: "/notifications",
        component: views.Notifications,
        name: "notifications",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/profile",
        name: "profile",
        component: views.Profile,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {


            checkOneSignalSubscription(store);

            (async () => {
                try {
                    const userRole = store.getters.getAccountType;
                    // const scripts = store.getters.GET_PHARMACY_SCRIPTS_COUNT;
                    // const software = store.getters.GET_PHARMACY_SOFTWARE;
                    // const services = store.getters.GET_PHARMACY_SERVICES;
                    await Promise.all([
                        store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS"),
                        store.dispatch("SET_CURRENT_USER_DATA", {
                            with:
                                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                        }),
                    ]);
                    // if (
                    //     userRole === "pharmacy" &&
                    //     !scripts.length &&
                    //     !software.length &&
                    //     !services.length
                    // ) {
                    //     store.dispatch("GET_ENVIRONMENT");
                    //     store.dispatch("GET_USER_ENVIRONMENT");
                    // }
                    if (
                        userRole === "pharmacy"
                    ) {
                        store.dispatch("GET_ENVIRONMENT");
                        store.dispatch("GET_USER_ENVIRONMENT");
                    }

                    next();
                } catch (error) {
                    next({
                        name: "home",
                    });
                }
            })();
        },
    },
    {
        path: "/my-profile",
        name: "my_profile",
        component: views.EmployerMyProfile,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {


            checkOneSignalSubscription(store);

            (async () => {
                try {
                    // const userRole = store.getters.getAccountType;
                    // const scripts = store.getters.GET_PHARMACY_SCRIPTS_COUNT;
                    // const software = store.getters.GET_PHARMACY_SOFTWARE;
                    // const services = store.getters.GET_PHARMACY_SERVICES;
                    await Promise.all([
                        store.dispatch("SET_CURRENT_USER_DATA", {
                            with:
                                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                        }),
                    ]);
                    // if (
                    //     userRole === "pharmacy" &&
                    //     !scripts.length &&
                    //     !software.length &&
                    //     !services.length
                    // ) {
                    //     store.dispatch("GET_ENVIRONMENT");
                    //     store.dispatch("GET_USER_ENVIRONMENT");
                    // }
                    // if (
                    //     userRole === "pharmacy"
                    // ) {
                    //     store.dispatch("GET_ENVIRONMENT");
                    //     store.dispatch("GET_USER_ENVIRONMENT");
                    // }

                    next();
                } catch (error) {
                    next({
                        name: "home",
                    });
                }
            })();
        },
    },

    {
        path: "/profile/edit",
        name: "profile_edit",
        component: views.ProfileEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS"),
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                            store.dispatch("GET_ENVIRONMENT"),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },
    {
        path: "/employer/profile/edit",
        name: "employer_profile_edit",
        component: views.EmployerEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            // let userData = store.getters.GET_USER_DATA;
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("GET_PHARMACY_ADDITIONAL_INFO_FIELDS"),
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },
    {
        path: "/profile/edit-basic-ie",
        name: "basic_profile_edit_ie",
        component: views.InternalEmplyeeProfileEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                            store.dispatch("GET_ENVIRONMENT"),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },

    {
        path: "/profile/photo",
        component: views.UserPhoto,
        name: "profile_photo",
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            let userData = store.getters.GET_USER_DATA;
            if (!from.name) {
                from.name = "home";
            }
            store.dispatch("setAuthPageBack", from.name);

            if (userData.image || from.name != "profile") {
                next();
            } else {
                (async () => {
                    try {
                        await store.dispatch("SET_CURRENT_USER_DATA", {
                            with: "settings,push_notifications",
                        }),
                            next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            }
        },
    },

    {
        path: "/profile/payout",
        component: views.UserPayout,
        name: "profile_payout",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
    },
    {
        path: "/profile/business",
        component: views.UserBusiness,
        name: 'profile_business',
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: 'home',
                type: 'locum'
            }
        }
    },

    {
        path: "/profile/ahpra",
        component: views.UserAhpra,
        name: "profile_ahpra",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
    },

    {
        path: "/profile/payment",
        component: views.ProfilePayment,
        name: "profile_payment",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
    },

    {
        path: "/profile/invoces",
        component: views.ProfileInvoices,
        name: "profile_invoices",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/notifications",
        component: views.ProfileNotifications,
        name: "profile_notifications",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/preferred-state",
        component: views.PreferredState,
        name: "profile_preferred_state",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
    },

    {
        path: "/profile/gst",
        name: "profile_gst",
        component: views.ProfileGst,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
    },
    {
        path: "/profile/super",
        name: "profile_super",
        component: views.UserSuper,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
        beforeEnter(to, from, next) {




            (async () => {
                try {

                    await Promise.all([
                        store.dispatch("SET_CURRENT_USER_DATA", {
                            with:
                                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                        }),
                    ]);

                    next();
                } catch (error) {
                    next({
                        name: "home",
                    });
                }
            })();
        },
    },

    {
        path: "/profile/travel",
        name: "profile_travel",
        component: views.UserTravel,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "auth_name",
                type: "locum",
            },
        },
    },
    {
        path: "/profile/covid-cert",
        name: "profile_covid_cert",
        component: views.CovidCerf,
        meta: {
            requiresAuth: false,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
            beforeEnter(to, from, next) {
                (async () => {
                    try {
                        next();
                    } catch (error) {
                        console.log(error);
                    }
                })();
            },
        },
    },
    {
        path: "/profile/personal-cert",
        name: "profile_personal_cert",
        component: views.PersonalCert,
        meta: {
            requiresAuth: false,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
            beforeEnter(to, from, next) {
                (async () => {
                    try {
                        next();
                    } catch (error) {
                        console.log(error);
                    }
                })();
            },
        },
    },
    {
        path: "/profile/languages",
        name: "profile_languages",
        component: views.UserLanguages,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "locum",
            },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    await store.dispatch("GET_LANGUAGES_LIST");
                    next();
                } catch (error) {
                    console.log(error);
                }
            })();
        },
    },

    {
        path: "/profile/gallery",
        name: "profile_gallery",
        component: views.UserGallery,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    const resp = await store.dispatch("GET_USER_GALLERY");
                    to.params.files = resp.data;
                    next();
                } catch (error) {
                    console.log(error);
                }
            })();
        },
    },
    {
        path: "/profile/earning-report",
        component: views.EarningReport,
        name: "profile_earning_report",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "job_seeker_index",
                type: "locum",
            },
        },
    },
    {
        path: "/internal-pool/update-preference",
        component: views.InternalPoolUserUpdatePreference,
        name: "internal_pool_user_update_preference",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/subscription-details",
        component: views.Subscription,
        name: "profile_subscription_details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/change-password",
        component: () => import("@/views/Auth/Password/Password.vue"),
        name: "password_change",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/request-account-deletion",
        component: () => import("@/views/Profile/RequestAccountDeletion/RequestAccountDeletion.vue"),
        name: "account_deletion",
        meta: {
            requiresAuth: true,
        },
    },


    {
        path: "/new-password",
        component: () => import("@/views/Auth/Password/Password.vue"),
        name: "password_new",
        meta: {
            // requiresAuth: true,
            requiresNotAuth: true,
        },
    },

    {
        path: "/calendar/:date?",
        name: "calendar",
        // component: views.Calendar,
        component: () => import("@/views/Calendar/Calendar.vue"),
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            checkOneSignalSubscription(store);
            store.dispatch("SET_CURRENT_USER_DATA", {
                with: "settings",
                navigation: "calendar",
                hideLoading: true,
            });
            if (store.getters.GET_USER_DATA.role === "job-seeker") {
                next({
                    name: 'job_seeker_index',
                });
              }
            next();
        },
    },

    {
        path: "/chat",
        name: "chat",
        component: views.Chat,
        meta: {
            requiresAuth: true,
        },

        beforeEnter(to, from, next) {
            if (to.name == "chat_list" || to.name == "chat_message") {
                next();
            } else {
                next({
                    name: "chat_list",
                });
            }
        },

        children: [
            {
                path: "",
                name: "chat_list",
                component: () => import("@/views/Chat/List/List.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            await store.dispatch("GET_CHAT_LIST");
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
            {
                path: ":chatId",
                name: "chat_message",
                component: () => import("@/views/Chat/Message/Message.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            // await store.dispatch('CREATE_CHAT', to.params.opponentId);
                            await store.dispatch("GET_CHAT_MESSAGES", to.params.chatId);

                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
        ],
    },

    {
        path: "/job-seeker/chat",
        name: "job_seeker_chat",
        component: views.Chat,
        meta: {
            requiresAuth: true,
        },

        beforeEnter(to, from, next) {
            if (to.name == "job_seeker_chat_list" || to.name == "job_seeker_chat_message") {
                next();
            } else {
                next({
                    name: "chat_list",
                });
            }
        },

        children: [
            {
                path: "",
                name: "job_seeker_chat_list",
                component: () => import("@/views/Chat/List/List.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            await store.dispatch("GET_CHAT_LIST");
                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
            {
                path: ":chatId",
                name: "job_seeker_chat_message",
                component: () => import("@/views/Chat/Message/Message.vue"),
                beforeEnter(to, from, next) {
                    (async () => {
                        try {
                            // await store.dispatch('CREATE_CHAT', to.params.opponentId);
                            await store.dispatch("GET_CHAT_MESSAGES", to.params.chatId);

                            next();
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                },
            },
        ],
    },

    {
        path: "/support",
        name: "support",
        component: views.Support,
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/:userId",
        name: "report",
        component: views.Support,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != undefined) {
                store.getters["getPageBack"]({
                    state: "report",
                    remove: true,
                });

                store.dispatch("setPageBack", {
                    state: "report",
                    // pageName: from.name,
                    page: {
                        name: from.name,
                        path: to.params.path || from.path,
                    },
                });
            }
            next();
        },
    },

    {
        path: "/dispute/:shiftId",
        name: "dispute",
        component: views.Support,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != undefined) {
                store.getters["getPageBack"]({
                    state: "dispute",
                    remove: true,
                });

                store.dispatch("setPageBack", {
                    state: "dispute",
                    // pageName: from.name,
                    page: {
                        name: from.name,
                        path: to.params.path || from.path,
                    },
                });
            }
            next();
        },
    },

    {
        path: "/emergency-contact",
        name: "emergency_contact",
        component: views.EmergencyContact,
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/about",
        name: "about",
        component: views.About,
    },
    {
        path: "/common-about",
        name: "common_about",
        component: views.CommonAbout,
    },

    {
        path: "/privacy-policy",
        name: "privacy_policy",
        component: views.Privacy,
    },
    {
        path: "/privacy-policy",
        name: "privacy_policy2",
        component: views.Privacy,
    },
    {
        path: "/privacy-policy",
        name: "privacy_policy_update",
        component: views.Privacy,
    },

    {
        path: "/terms-and-conditions",
        name: "terms_and_conditions",
        component: views.Terms,
    },
    {
        path: "/terms-and-conditions-guest-shift",
        name: "terms_and_conditions_guest_shift",
        component: views.Terms,
    },
    {
        path: "/terms-and-conditions",
        name: "terms_and_conditions2",
        component: views.Terms,
    },
    {
        path: "/terms-and-conditions",
        name: "terms_and_conditions_update",
        component: views.Terms,
    },
    {
        path: "/verify/mobile",
        name: "verify_mobile_number",
        component: () => import("@/views/Verify/Verify.vue"),
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/verify/email",
        name: "verify_email",
        component: () => import("@/views/Verify/Verify.vue"),
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/profile/documents",
        component: views.Documents,
        name: "profile_documents",
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {


            checkOneSignalSubscription(store);

            (async () => {
                try {
                    const userRole = store.getters.getAccountType;
                    const scripts = store.getters.GET_PHARMACY_SCRIPTS_COUNT;
                    const software = store.getters.GET_PHARMACY_SOFTWARE;
                    const services = store.getters.GET_PHARMACY_SERVICES;
                    await Promise.all([
                        store.dispatch("SET_CURRENT_USER_DATA", {
                            with:
                                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                        }),
                    ]);
                    if (
                        userRole === "pharmacy" &&
                        !scripts.length &&
                        !software.length &&
                        !services.length
                    ) {
                        store.dispatch("GET_ENVIRONMENT");
                        store.dispatch("GET_USER_ENVIRONMENT");
                    }

                    next();
                } catch (error) {
                    next({
                        name: "home",
                    });
                }
            })();
        },
    },
    {
        path: "/profile/identity",
        component: views.IdentityDocuments,
        name: "profile_identity_documents",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/insurance",
        component: views.InsuranceDocuments,
        name: "profile_insurance_documents",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/profile/cv',
        component: views.Cv,
        name: 'profile_cv',
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/profile/cv',
        component: views.Cv,
        name: 'profile_cv',
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile-software-experience",
        component: views.UserSoftwareExperience,
        name: "profile_software_experience",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "locum",
            },
        },
    },
    {
        path: "/profile-pharmacy-certification",
        component: views.UserPharmacistCertification,
        name: "profile_pharmacy_certification",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "locum",
            },
        },
    }, 
    {
        path: "/experience/edit",
        name: "experience_edit",
        component: views.LocumExperienceEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                        ]);
                        next();
                    } catch (error) {
                        console.log("🚀 ~ error:", error)
                        
                    }
                })();
        },
    },
    {
        path: "/redirect-me",
        redirect: {
            name: "home",
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: views.NotFound,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/bank-account",
        component: views.BankAccountFirstTime,
        name: "bank_account",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/preferred-locum",
        component: () => import("@/views/PreferredLocum/PreferredLocum.vue"),
        name: "manage_preferred_locum",
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            const user = store.getters.GET_USER_DATA;
            if (user.settings !== null && user?.settings.preferredLocumEnabled === 1) {
                next();
            } else {
                next({
                    name: "profile",
                });
            }
        }
    },
    {
        path: "/multiple-internal-pool",
        component: () => import("@/views/MultipleInternalPool/MultipleInternalPool.vue"),
        name: "manage_multiple_internal_pool",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/guest-locum",
        component: () => import("@/views/GuestLocum/GuestLocum.vue"),
        name: "manage_guest_locum",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bank-account/change",
        name: "bank_account_change",
        component: views.ChangeBankAccount,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "billingInfo",
                            }),
                            store.dispatch("GET_ENVIRONMENT"),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },
    {
        path: "/verify-mobile",
        name: "verify_mobile",
        component: views.VerifyMobile,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: "/bank-account/edit",
        name: "bank_account_edit",
        component: views.EditBankAccount,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "billingInfo",
                            }),
                            store.dispatch("GET_ENVIRONMENT"),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },
    {
        path: "/bank-account/verify-deposit",
        name: "bank_account_verify",
        component: views.VerifyDeposit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            if (from.name != "profile") {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "billingInfo",
                            }),
                            store.dispatch("GET_ENVIRONMENT"),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            } else {
                next();
            }
        },
    },

    {
        path: "/role-details",
        name: "role-details",
        component: views.RoleDetails,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "home",
                type: "pharmacy",
            },
        },
    },
    //   {
    //     path: "/agency-shift",
    //     name: "agency-shift",
    //     component: views.AgencyShift,
    //     meta: {
    //       requiresAuth: true,
    //       requiresAccountType: {
    //         redirect: "home",
    //         type: "pharmacy",
    //       },
    //     },
    //   },

    {
        path: "/preferred-locum-stores",
        component: () => import("@/views/PreferredLocum/PreferredLocumStores.vue"),
        name: "manage_preferred_locum_stores",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/preferred-locum/invite",
        component: () => import("@/views/PreferredLocum/InvitePreferredLocum.vue"),
        name: "invite_preferred_locum",
        meta: {
            requiresAuth: true,
        },


    },
    {
        path: "/internal-pool/invite",
        component: () => import("@/views/MultipleInternalPool/InviteInternalPool.vue"),
        name: "invite_internal_pool",
        meta: {
            requiresAuth: true,
        },


    },

    {
        path: "/guest-locum/invite",
        component: () => import("@/views/GuestLocum/InviteGuestLocum.vue"),
        name: "invite_guest_locum",
        meta: {
            requiresAuth: true,
        },


    },

    {
        path: "/preferred-locum/profile/:invitationId",
        component: () => import("@/views/PreferredLocum/PreferredLocumProfile.vue"),
        name: "profile_preferred_locum",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/preferred-locum/unavailable",
        name: "preferred_unavailable",
        component: views.NoPrefferdInvitation,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/internal-pool/unavailable",
        name: "internal_pool_unavailable",
        component: views.NoInternalPoolInvitation,
        meta: {
            requiresAuth: false,
        },
    },

    {
        path: "/preferred-locum/invitation/:invitationId",
        component: views.PreferredLocumConfirm,
        name: "preferred_locum_confirmation",
        meta: {
            requiresAuth: false,
        },

        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const preferredInfo = await store.dispatch("GET_PREFERRED_LOCUM_INFO", {
                        invitationId: to.params.invitationId,
                    });
                    console.log("yelahabibi", preferredInfo);
                    if (preferredInfo.verified == true) {
                        next({
                            name: "preferred_unavailable",
                        });
                    } else {
                        let userData = store.getters.GET_USER_DATA;
                        if (userData.id != null) {
                            if (userData.email == preferredInfo.locumEmail) {
                                next();
                            } else {
                                next({
                                    name: "NotFound",
                                })
                            }
                        } else {
                            next();
                        }
                    }


                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
     {
        path: "/internal-pool/invitation/:invitationId",
        component: views.InternalPoolConfirm,
        name: "internal_pool_confirmation",
        meta: {
            requiresAuth: false,
        },

        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const preferredInfo = await store.dispatch("GET_INTERNAL_POOL_INFO", {
                        invitationId: to.params.invitationId,
                    });

                    const invitation = preferredInfo.invitation;
                    const accepted = invitation?.acceptedAt !== null;
                    const rejected = invitation?.rejectedAt !== null;

                    if (accepted || rejected) {
                        next({
                            name: "internal_pool_unavailable",
                        });
                    } else {
                        let userData = store.getters.GET_USER_DATA;
                        if (userData.id != null) {
                            if (userData.email == preferredInfo.locumEmail) {
                                next();
                            } else {
                                next({
                                    name: "NotFound",
                                })
                            }
                        } else {
                            next();
                        }
                    }


                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
    {
        path: "/shift_application/unavailable",
        name: "shift_application_unavailable",
        component: views.NoshiftApplication,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/guest-locum/invitation/:invitationId",
        component: views.GuestLocumConfirm,
        name: "guest_locum_confirmation",
        meta: {
            requiresAuth: false,
        },

        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const guestInfo = await store.dispatch("GET_GUEST_LOCUM_INFO", {
                        invitationId: to.params.invitationId,
                    });
                    console.log("yelahabibi", guestInfo);
                    if (guestInfo.verified == true) {
                        next({
                            name: "guest_unavailable",
                        });
                    } else {
                        let userData = store.getters.GET_USER_DATA;
                        if (userData.id != null) {
                            if (userData.email == guestInfo.guestLocumEmail) {
                                next();
                            } else {
                                next({
                                    name: "NotFound",
                                })
                            }
                        } else {
                            next();
                        }
                    }


                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },

    {
        path: "/shift_application/:shiftApplicationId",
        name: "shift_application_details",
        component: views.ShiftApplicationPreview,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    const shiftApplicationDetails = await store.dispatch("GET_SHIFT_APPLICATION_DETAILS", {
                        shiftApplicationId: to.params.shiftApplicationId,
                    });
                    if (shiftApplicationDetails.isLinkExpired) {
                        if (shiftApplicationDetails.shiftAvailable) {
                            next({
                                name: "job_book_days",
                                params: {
                                    jobId: shiftApplicationDetails.jobId
                                },
                            });
                        }
                        next({
                            name: "shift_application_unavailable",
                        });
                    }
                    next();
                } catch (error) {
                    console.log(error)
                }
            })();
        },
    },
    {
        path: "/view_profile/:userId",
        name: "view_profile",
        component: views.ViewProfile,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const preferredInfo = await store.dispatch("GET_PROFILE_USER_INFO", {
                        userId: to.params.userId,
                    });
                    console.log("yelahabibi", preferredInfo);

                    let userData = store.getters.GET_USER_DATA;
                    if (userData.id != null) {
                        next();
                    } else {
                        next({
                            name: "NotFound",
                        })
                    }


                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
    {
        path: "/award_shift/:shiftAppId/:pharmacyId/:locumId",
        name: "award_shift",
        component: views.AwardShift,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const response = await store.dispatch("GET_AWARD_SHIFT_DETAIL_INFO", {
                        shiftAppId: to.params.shiftAppId,
                        pharmacyId: to.params.pharmacyId,
                        locumId: to.params.locumId,
                    });
                    console.log("yelahabibi", response);

                    let userData = store.getters.GET_USER_DATA;
                    if (userData.id != null && response.success == true) {
                        next();
                    } else {
                        next({
                            name: "NotFound",
                        })
                    }


                } catch (error) {
                    // next({
                    //     name: "home",
                    // });
                }
            })();

        },
    },
    {
        path: "/profile/agency-note-list",
        component: views.AgencyNoteAndRates,
        name: "profile_list_agency_note",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/agency-note/:id",
        component: views.AgencyNote,
        name: "profile_agency_note",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/profile/add-agency-note",
        component: views.AddAgencyNote,
        name: "profile_add_agency_note",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/internal-employee/invitation/:invitationId",
        component: views.EmployeeConfirm,
        name: "employee_confirmation",
        meta: {
            requiresAuth: false,
        },
        beforeEnter(to, from, next) {

            (async () => {
                try {
                    const internalInfo = await store.dispatch("GET_EMPLOYEE_LOCUM_INFO", {
                        invitationId: to.params.invitationId,
                    });
                    console.log("yelahabibi", internalInfo);
                    if (internalInfo.verified == true) {
                        next({
                            name: "employee_confirmation_unavailable",
                        });
                    } else {
                        next();

                    }

                } catch (error) {
                    console.log("🚀 ~ file: router.js:2916 ~ error:", error)
                }
            })();

        },
    },
    {
        path: "/internal-employee/unavailable",
        name: "employee_confirmation_unavailable",
        component: views.UnavailableConfirm,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/profile/blocked-pharmacies",
        name: "profile_blocked_pharmacies",
        component: views.LocumBlockedPharmacies,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "locum",
            },
        },
    },

    {
        path: "/job-poster/index",
        component: views.JobPosterIndex,
        name: "job_poster",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-poster/applicants/list/:jobId",
        component: views.JobApplicantsListingComponent,
        name: "job_poster_applicants_list",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-poster/applicant/:applicationId",
        component: views.JobApplicantDetailComponent,
        name: "job_applicant_details",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-poster/job/filter",
        component: views.JobPosterJobFilterPage,
        name: "job_poster_job_filter",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-poster/previous/filter",
        component: views.JobPosterPreviousFilterPage,
        name: "job_poster_previous_filter",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-poster/applicants/filter",
        component: views.JobPosterApplicantsFilterPage,
        name: "job_poster_applicants_filter",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-poster/edit/:jobId",
        component: views.JobPosterEdit,
        name: "edit_job_list",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-poster/edit/payment/:jobId",
        component: views.JobPosterEditPayment,
        name: "edit_payment_job_list",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "pharmacy",
            },
        },
    },
    {
        path: "/job-seeker/index",
        component: views.JobSeekerIndex,
        name: "job_seeker_index",
        meta: {
            requiresAuth: true,
            // requiresAccountType: {
            //     type: "job-seeker",
            // },
        },
        beforeEnter(to, from, next) {
         
            let userData = store.getters.GET_USER_DATA;
            if(userData.locumOnboardedAsJobseeker == 0 && userData.role == "locum"){
                next({
                    name: "welcome_locum_jobseeker",
                });
            }else{

                next();
            }
        }
    },
    {
        path: "/job-seeker/applications",
        component: views.JobSeekerMyApplications,
        name: "job_seeker_my_applications",
        meta: {
            requiresAuth: true,
            // requiresAccountType: {
            //     type: "job-seeker",
            // },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    await store.dispatch("GET_NOTIFICATIONS_MESSAGES", {
                        params: {
                          hideLoading: true,
                        },
                      });
        
                } catch (error) {
                    console.log(error);
                   
                }
            })();
            
            next();
        }
    },
    {
        path: "/job-seeker/previous-applications",
        component: views.JobSeekerPreviousApplications,
        name: "job_seeker_previous_applications",
        meta: {
            requiresAuth: true,
            // requiresAccountType: {
            //     type: "job-seeker",
            // },
        },
        beforeEnter(to, from, next) {
            (async () => {
                try {
                    await store.dispatch("GET_NOTIFICATIONS_MESSAGES", {
                        params: {
                          hideLoading: true,
                        },
                      });
        
                } catch (error) {
                    console.log(error);
                   
                }
            })();
            
            next();
        }
    },
    {
        path: "/job-seeker/applications",
        component: views.JobSeekerApplications,
        name: "job_seeker_applications",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/browse/filter",
        component: views.BrowseJobFilterPage,
        name: "job_seeker_browse_filter",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/application/filter",
        component: views.ApplicationFilterPage,
        name: "job_seeker_application_filter",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/history/filter",
        component: views.HistoryFilterPage,
        name: "job_seeker_history_filter",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/applications-details/:jobId",
        component: views.ApplicationDetailsToApply,
        name: "job_seeker_application_details",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/applications-details-withdraw/:jobId",
        component: views.ApplicationDetailsToWithdraw,
        name: "job_seeker_application_withdraw",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/previous-applications-details/:jobId",
        component: views.HistoryJobDetails,
        name: "job_seeker_previous_application",
        meta: {
            requiresAuth: true,
           
        },
    },
    {
        path: "/job-seeker/profile",
        name: "job_seeker_profile",
        component: views.JobSeekerProfile,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {


            checkOneSignalSubscription(store);

            (async () => {
                try {
                    await Promise.all([
                        store.dispatch("SET_CURRENT_USER_DATA", {
                            with:
                                "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
                        }),
                    ]);
                  
                    next();
                } catch (error) {
                    next({
                        name: "home",
                    });
                }
            })();
        },
    },
    {
        path: "/job-seeker/profile/edit",
        name: "basic_profile_job_seeker",
        component: views.JobSeekerProfileEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "job_seeker_index",
                        });
                    }
                })();
        },
    },
    {
        path: "/job-seeker/additional/edit",
        name: "additional_profile_job_seeker",
        component: views.JobSeekerAdditionalEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "job_seeker_index",
                        });
                    }
                })();
        },
    },
    {
        path: "/job-seeker/profile/photo",
        component: views.UserPhoto,
        name: "profile_photo_job_seeker",
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            let userData = store.getters.GET_USER_DATA;
            if (!from.name) {
                from.name = "home";
            }
            store.dispatch("setAuthPageBack", from.name);

            if (userData.image) {
                next();
            } else {
                (async () => {
                    try {
                        await store.dispatch("SET_CURRENT_USER_DATA", {
                            with: "settings,push_notifications",
                        }),
                            next();
                    } catch (error) {
                        next({
                            name: "job_seeker_index",
                        });
                    }
                })();
            }
        },
    },
    {
        path: "/job-seeker/profile/setting",
        component: views.JobseekerSetting,
        name: "profile_job_seeker_setting",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/job-seeker/change/photo",
        component: views.JobseekerChangePhoto,
        name: "job_seeker_change_photo",
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
            
            
            store.dispatch("setAuthPageBack", from.name);

           
                (async () => {
                    try {
                        await store.dispatch("SET_CURRENT_USER_DATA", {
                            with: "settings,push_notifications",
                        }),
                            next();
                    } catch (error) {
                        next({
                            name: "home",
                        });
                    }
                })();
            
        },
    },
    {
        path: "/job-seeker/subscribe",
        name: "subscribe_jobs",
        component: views.SubscribeJobs,
        meta: {
            requiresAuth: true,
            // requiresAccountType: {
            //     type: "job-seeker",
            // },
        },
    },
    {
        path: "/job-seeker/unsubscribe",
        name: "unsubscribe_jobs",
        component: views.UnsubscribeJobs,
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "job-seeker",
            },
        },
    },
    {
        path: "/job-listing/guest",
        name: "job-listing-guest",
        component: views.JobLisitingGuestHome,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/job-listing/guest/job-details/:jobId",
        component: views.JobLisitingGuestJobDetail,
        name: "job-listing-guest-job-detail",
        meta: {
            requiresAuth: false,
           
        },
        beforeEnter(to, from, next) {
            let user = store.getters.isAuthenticated;
            let userData = store.getters.GET_USER_DATA;
            if (user && userData.role !== 'pharmacy') {
                next({
                    name: "job_seeker_application_details",
                    params: { jobId: to.params.jobId },
                });
            } else {
                next();
            }
        },
    },
    {
        path: "/create/option",
        component: views.CreateOption,
        name: "create_option",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/job-seeker/profile-software-experience",
        component: views.UserSoftwareExperience,
        name: "profile_job_seeker_software_experience",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "job-seeker",
            },
        },
    },
    {
        path: "/job-seeker/profile-pharmacy-certification",
        component: views.UserPharmacistCertification,
        name: "profile_job_seeker_pharmacy_certification",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "job-seeker",
            },
        },
    }, 
    {
        path: "/job-seeker/profile-universities",
        component: views.SeekerUniversities,
        name: "profile_job_seeker_universitites",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "job-seeker",
            },
        },
    },
    {
        path: "/job-seeker/registration-year",
        component: views.SeekerRegistrationYear,
        name: "profile_job_seeker_registration",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                type: "job-seeker",
            },
        },
    },
    {
        path: "/job-listing/guest/subscribe",
        name: "guest_subscribe_jobs",
        component: views.SubscribeJobs,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/preferences",
        name: "preferences",
        component: views.Preferences,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/job-listing/guest/subscribe/confirm/:subscriptionId",
        name: "guest_subscribe_jobs_confirm",
        component: views.ConfirmJobAlert,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/job-listing/guest/unsubscribe/:subscriptionId",
        name: "guest_unsubscribe_jobs",
        component: views.UnsubscribeJobs,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/locum/onboard/jobseeker/additional",
        name: "additional_onboard_locum_job_seeker",
        component: views.JobSeekerAdditionalEdit,
        meta: {
            requiresAuth: true,
        },
        beforeEnter(to, from, next) {
                (async () => {
                    try {
                        await Promise.all([
                            store.dispatch("SET_CURRENT_USER_DATA", {
                                with:
                                    "settings,billingInfo,schedule,address,push_notifications",
                            }),
                        ]);
                        next();
                    } catch (error) {
                        next({
                            name: "job_seeker_index",
                        });
                    }
                })();
        },
    },
    {
        path: "/welcome-locum-jobseeker",
        name: "welcome_locum_jobseeker",
        component: views.NormalLocumToJobseekerWelcome,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/locum/onboard/jobseeker/cv",
        name: "locum_jobseeker_cv",
        component: views.LocumJobseekerCv,
        meta: {
            requiresAuth: true,
            
        },
    },
    {
        path: "/locum/onboard/jobseeker/enhance",
        name: "locum_jobseeker_enhance",
        component: views.JobseekerEnhance,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/locum/onboard/jobseeker/preview",
        name: "locum_jobseeker_preview",
        component: views.JobseekerPreview,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/locum/onboard/jobseeker/software-experience",
        component: views.UserSoftwareExperience,
        name: "locum_jobseeker_software_experience",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "auth_name",
                type: "locum",
            },
        },
        // beforeEnter(to, from, next) {
        //     let userData = store.getters.GET_USER_DATA;
        //     if(userData.customFields && userData.customFields.softwareExperience) {
        //         next({
        //             name: "locum_jobseeker_pharmacist_certifications",
        //         });
        //     } else {
        //         next();
        //     }
        // },
    },    
    {
        path: "/locum/onboard/jobseeker/pharmacist-certifications",
        component: views.UserPharmacistCertification,
        name: "locum_jobseeker_pharmacist_certifications",
        meta: {
            requiresAuth: true,
            requiresAccountType: {
                redirect: "auth_name",
                type: "locum",
            },
        },
        // beforeEnter(to, from, next) {
        //     let userData = store.getters.GET_USER_DATA;
        //     if(userData.customFields && userData.customFields.certificates) {
        //         next({
        //             name: "auth_availability_week",
        //         });
        //     } else {
        //         next();
        //     }
        // },
    },
    {
        path: "/locum/shift/accepted/preview",
        name: "locum_shift_preview",
        component: views.ShiftAcceptPreview,
    },
    {
        path: "/locum/shift/reject/preview",
        name: "locum_shift_reject_preview",
        component: views.ShiftRejectPreview,
    },
    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: "smooth"
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
    routes,
});

router.beforeEach((to, from, next) => {

    if (from.name) {
        store.dispatch("setLastPage", from.path);
    }




    if (to.matched.some((record) => record.meta.requiresAuth)) {

        if(to.fullPath =='/profile/edit#update_script' && !store.getters.isAuthenticated){
            localStorage.setItem('previous_url', to.fullPath);
        } else {
            localStorage.removeItem('previous_url');
        }

        if (!store.getters.isAuthenticated) {
            store.commit('setRedirectRoute', to);
            next({
                name: "get_start_one",
            });
        } else {
            if (store.getters.getRedirectRoute) {
                next(store.getters.getRedirectRoute);
                store.commit('clearRedirectRoute');
            }
            const userData = store.getters.GET_USER_DATA;
            if (userData.role === 'locum' && (userData.isInternalLocum)) {

                store.dispatch("SET_CURRENT_USER_DATA", {
                    with:
                        "settings,billingInfo,schedule,bankVerification,airwallexInfo,address,push_notifications,config.hours_before_shift_lock",
                });

                if (userData.internalEmployeeEnable == 0) {
                    store.dispatch("AUTH_LOGOUT");
                    next({
                        name: "auth",
                    });
                }
            }

            if(userData.role === 'job-seeker'){
                
                if(!to.fullPath.includes('auth') && !to.fullPath.includes('notifications') && !to.fullPath.includes('verify') && !to.fullPath.includes('change-password')){
                    if (!to.fullPath.includes('job-seeker')) {
                        next({
                            name: 'job_seeker_index',
                        });
                    }
                }
              
            }
            
            if (!userData.email || !userData.role) {
                store.dispatch("AUTH_LOGOUT");
            }


            if (userData.emailVerified && !userData.mobileNumber_verified) {
                //
                if (to.name != "auth_mobile") {
                    //
                    if (!userData.mobileNumber) {
                        next({
                            name: "auth_mobile",
                        });
                    } else if (to.name != "auth_verify") {
                        next({
                            name: "auth_mobile",
                        });
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            } else if (!userData.emailVerified && to.name != "auth_verify") {
                next({
                    name: "auth_verify",
                });
            } else if (to.meta.requiresAccountType) {
               
                const accountType = store.getters.getAccountType;
                const requiredTypes = Array.isArray(to.meta.requiresAccountType.type)
                    ? to.meta.requiresAccountType.type
                    : [to.meta.requiresAccountType.type];

                if (accountType === 'job-seeker') {
                    if (requiredTypes.includes('locum') || requiredTypes.includes('pharmacy')) {
                        next({
                            name: 'job_seeker_index',
                        });
                    }
                }

                if (!requiredTypes.includes(accountType)) {
                    next({
                        name: to.meta.requiresAccountType.redirect,
                    });
                } else {
                    next();
                }
            } else if (
                to.name != "verify_mobile_number" &&
                to.name != "verify_email"
            ) {
                if (store.getters.getVerifyPageData.mobileNumber) {
                    next({
                        name: "verify_mobile_number",
                    });
                } else if (store.getters.getVerifyPageData.email) {
                    next({
                        name: "verify_email",
                    });
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    } else if (to.matched.some((record) => record.meta.requiresNotAuth)) {
        if (store.getters.isAuthenticated) {
            next({
                name: "home",
            });
        } else {
            next();
        }
    } else {
        next();
    }
});



export default router;
